import React, { createContext, useContext } from 'react'
import { useQuiz } from '../QuizProvider'

const WhatKindOfLeaderContext = createContext()

const useWhatKindOfLeader = () => {
  return useContext(WhatKindOfLeaderContext)
}

export default useWhatKindOfLeader

export const WhatKindOfLeaderProvider = ({ children }) => {
  const { quizIndex, trackContent, setTrackContent } = useQuiz()

  const handleOptionClick = (choice, type) => {
    trackContent[quizIndex + 1] = { choice: choice, type: type }
    setTrackContent({
      ...trackContent,
    })
  }

  const value = {
    handleOptionClick,
  }

  return (
    <WhatKindOfLeaderContext.Provider value={value}>
      {children}
    </WhatKindOfLeaderContext.Provider>
  )
}
